import { render, staticRenderFns } from "./TdStatus.vue?vue&type=template&id=5a8e4055&scoped=true&"
import script from "./TdStatus.vue?vue&type=script&lang=js&"
export * from "./TdStatus.vue?vue&type=script&lang=js&"
import style0 from "./TdStatus.vue?vue&type=style&index=0&id=5a8e4055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8e4055",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VIcon,VList,VMenu,VRow})
